// src/utils/timetableSlotTypes.ts

export const NO_SUBJECT_SLOT_TYPES = ['break', 'power_nap', 'workbook', 'activities'] as const;
export const NO_TEACHER_SLOT_TYPES = ['break'] as const;
export const OPTIONAL_TEACHER_SLOT_TYPES = ['power_nap', 'workbook', 'activities'] as const;

export const hasNoSubject = (slotType: string | null | undefined): boolean =>
  !!slotType && (NO_SUBJECT_SLOT_TYPES as readonly string[]).includes(slotType);

export const hasNoTeacher = (slotType: string | null | undefined): boolean =>
  !!slotType && (NO_TEACHER_SLOT_TYPES as readonly string[]).includes(slotType);

export const hasOptionalTeacher = (slotType: string | null | undefined): boolean =>
  !!slotType && (OPTIONAL_TEACHER_SLOT_TYPES as readonly string[]).includes(slotType);

export const formatSlotTypeLabel = (slotType: string): string =>
  slotType
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');